import React, { useState } from "react";

export default function Forms(prop) {
    const handleOnClick = () => {
        let newText = text.toUpperCase();
        setText(newText);
    };
    const handleOnChange = (event) => {
        setText(event.target.value);
    };
    const clear = () =>{
        setText("")
    }
    const [text, setText] = useState("");
    return (
        <div className="container" style={{color: prop.mode === 'dark'?'white':'black'}}>
            <div className="col-8">
                <div className="mb-3">
                    <label
                        htmlFor="exampleFormControlTextarea1"
                        className="form-label">
                        FeedBack
                    </label>
                    <textarea
                        className="form-control"
                        id="exampleFormControlTextarea1"
                        value={text}
                        onChange={handleOnChange}
                        onClick={clear}
                        rows="8"
                        style={{backgroundColor: prop.mode === 'dark'?'grey':'white', 
                        color : prop.mode === 'dark'?'white':'black'}}></textarea>
                </div>
                <button className="btn btn-primary" onClick={handleOnClick}>
                    To Uppercase
                </button>
            </div>
            <div className="container my-3">
                <h1>Your TExt summary</h1>
                <p>
                    {text.split(" ").length} words and {text.length} characters
                </p>

            </div>
        </div>
    );
}
